<template>
    <article class="access_qr">
        <div class="access_qr__content" v-if="loaded">
          <div class="access_qr__header">
            <img
              :src="company ? company.url : ''"
              class="access_qr__header--logo"
            >
            <img
              src="https://fusepongsolutions.s3.us-west-2.amazonaws.com/email_assets/logo-fa.png"
              class="access_qr__header--logo"
            >
          </div>
          <div class="access_qr__location">
            Hola
            <p class="access_qr__location--name">
              {{ location_name }}
            </p>
            El técnico validará tu cita leyendo este código:
          </div>

          <div class="access_qr__mask" v-if="!loaded" >
            <img src="@/assets/img/qr-disabled.png">
          </div>

          <div v-else>
            <div class="access_qr__code">
              <vue-qrcode v-if="qr" :value="code" :options="{ width: 160 }"></vue-qrcode>
              <vue-qrcode v-if="qr" :value="code" :options="{ width: 160 }"></vue-qrcode>
            </div>
            <div class="access_qr__code">
              <vue-qrcode v-if="qr" :value="code" :options="{ width: 160 }"></vue-qrcode>
              <vue-qrcode v-if="qr" :value="code" :options="{ width: 160 }"></vue-qrcode>
            </div>
            <div class="access_qr__code">
              <vue-qrcode v-if="qr" :value="code" :options="{ width: 160 }"></vue-qrcode>
              <vue-qrcode v-if="qr" :value="code" :options="{ width: 160 }"></vue-qrcode>
            </div>
          </div>

          <div class="access_qr__invitation_dates">
              <p class="access_qr__invitation_dates--title">Fecha y hora de la cita:</p>
              <div class="access_qr__start_time" style="margin-bottom: 34px;">
               {{ new Date(booking_begin) | moment("LL")}} | {{ new Date(booking_begin) | moment("h:mm a")}}
              </div>

              <!-- <p class="access_qr__invitation_dates--title">Válido hasta:</p>
              <div class="access_qr__start_time" style="border: 3px solid #FF6300;">
                {{ new Date(booking_end) | moment("LL")}} | {{ new Date(booking_end) | moment("h:mm a")}}
              </div> -->
          </div>
        </div>

        <div class="faccess_info_card">
          <div class="faccess_info_card__header">
            <img
                src="https://fusepongsolutions.s3.us-west-2.amazonaws.com/email_assets/fuseaccess_more.png"
            >
          </div>
          <div class="faccess_info_card__body">
            <p class="faccess_info_card__body--contact_us">Contáctanos</p>
            <a href="mailto:comercial@fusepong.com" class="faccess_info_card__body--email">comercial@fusepong.com</a>
            <a href="https://fuseaccess.com" class="faccess_info_card__body--website">Visita nuestra web</a>
          </div>
        </div>

        <div class="access_qr__footer">
          <img src="@/assets/img/faccess_logo.svg">
        </div>


        <!--<div class="code_qr" v-if="expired_invitation">
          <p style="text-align: center; font-size: 32px; margin-bottom: 20px !important">Lo sentimos, la invitación no es válida en este momento</p>
        </div>
        <div class="code_qr" v-else>
            <div class="code_qr__container">
                <h1 class="code_qr__container--title">Hola, bienvenido a {{getCompany().company_name}}</h1>
                <p class="code_qr__container--subtitle">
                    Puedes ingresar a tu ubicación <br>
                    con éste código
                </p>
                <div class="code_qr__container--qr">
                    <vue-qrcode v-if="qr" :value="code" :options="{ width: 200 }"></vue-qrcode>
                </div>
            </div>
        </div>-->
        <!-- <app-footer></app-footer> -->
    </article>

</template>
<script>
  export default {
    data(){
      return{
        expired_invitation: false,
        generate_qr: null,
        qr: true,
        code: null,
        params_user_id: null,
        params_booking_id: null,
        booking_begin: null,
        booking_end: null,
        params_location_name: null,
        qrcodes: [],
        expired_previous_entry: false,
        time_qr: '',
        initial_time: '',
        invitation: [],
        company: [],
        location_name: '',
        loaded: false
      }
    },
    mounted() {
      try{
        let vm = this;
        let params = this.$router.app._route.query
        if (JSON.stringify(params)!=='{}' && params.sublocation_id !== '' && params.booking_id !== '') {
          this.params_sublocation_id = params.sublocation_id
          this.params_booking_id = params.booking_id
          this.getBookingInfo()
        }
        document.title = 'Código QR';
      }catch(e){
        console.log('CodeQr not params ', e);
      }
    },
    destroy(){
        clearInterval(vm.generate_qr)
    },
    methods: {
      start(){
        console.log("=== start ===")
        var vm = this;
        clearInterval()
        vm.makeQRCode()
        vm.generate_qr = window.setInterval(function(){
        this.qr = false;
          vm.makeQRCode() /* : ''; */
        }, 9000)
      },
      getBookingInfo(){
        try {
          this.$http.get('app/bookings/get_booking_by_id?booking_id='+this.params_booking_id)
          .then(function(response){
            console.log('data', response.body.data)
              this.booking_begin = response.body.data.booking.start_time;
              this.booking_end = response.body.data.booking.end_time
              this.start();
          }, function(response){
              console.log(response.body.data)
          })
        } catch (e) {
          console.log(e.message)
        }
      },
      makeQRCode(){
        console.log('makeQRCode' )
        this.qr = true;
        let vm = this;
        vm.code = vm.params_sublocation_id
        console.log("Code => ", vm.code);
        vm.loaded = true
      },
    }
  }
</script>

<style scoped>
  .code_qr{
    margin: 0px;
  }
</style>



// WEBPACK FOOTER //
// src/components/views/invitations/VantiCodeQr.vue